export default {
    baseUrl:"https://sunny-books-server.onrender.com/"
}